'use client';

import { useMemo } from 'react';

import type { Project } from '@highlight-cp/project-api';

import { isProjectEditable } from './is-project-editable';

/**
 * ### useIsProjectEditable
 *
 * @description
 * Hook that checks whether the given project is in an editable status
 * ({@link PROJECT_STATUS.NOT_STARTED} or {@link PROJECT_STATUS.DRAFTING}).
 *
 * @example
 * const { data: project } = useGetCurrentProject();
 * const isEditable = useIsProjectEditable(project);
 *
 * @param project - Project API project (or subset with `status`)
 * @returns Whether the project can be edited
 */
const useIsProjectEditable = (project?: Pick<Project, 'status'> | null): boolean => {
  return useMemo(() => isProjectEditable(project), [project]);
};

export default useIsProjectEditable;
